import Event from "../event"
import {toMomentDate} from "../../../gd/convert/moment-date"

export type UpdateDateOptions = {
    keepCalendarDuration?   : boolean
}

export default function eventUpdateStartDate(event:Event, startDate:Moment|null, options:UpdateDateOptions={}) {
    let endStartDiff : number|undefined = undefined

    if (options.keepCalendarDuration && event.startDate && event.endDate) {
        endStartDiff = moment(event.endDate).diff(moment(event.startDate), 'days')
    }

    event.startDate = toMomentDate(startDate)

    // if we set start date to null, end date should be null too
    if (startDate === null) {
        event.endDate = null
    }

    if (event.startDate && !event.endDate) {
        event.endDate = toMomentDate(event.startDate)
    }

    // if endDate BEFORE start set start = end because we update START here
    if (event.startDate && event.endDate && event.endDate.isBefore(event.startDate,'days')) {
        event.endDate = toMomentDate(event.startDate)
    }

    if (options.keepCalendarDuration && event.startDate && endStartDiff!==undefined) {
        event.endDate    = moment(event.startDate).add(endStartDiff,'days')
    }
}